var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomizableViews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.183,
    height: 126.617,
    viewBox: "0 0 81.183 126.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M233.952,143.522a4.728,4.728,0,0,1-1.452-.264,4.379,4.379,0,0,1-2.375-2.243l-15.7-36.423-19.268,17.948a4.149,4.149,0,0,1-6.994-3.035V26.2a4.149,4.149,0,0,1,6.994-3.035l67.832,63.345a4.194,4.194,0,0,1,1.056,4.355,4.123,4.123,0,0,1-3.563,2.772l-26.79,2.374,16.5,35.9a4.383,4.383,0,0,1,.132,3.167,4.652,4.652,0,0,1-2.112,2.375L235.8,143.125a5.171,5.171,0,0,1-1.847.4Z",
    transform: "translate(-185.659 -19.405)",
    fill: "none",
    stroke: "#5fccf2",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableViews);
export default __webpack_public_path__ + "static/media/customizableViews.4d25999fa8c2ce1de9859ac40f404dd5.svg";
export { ForwardRef as ReactComponent };